




























import { Vue, Component, Watch } from 'vue-property-decorator';
import setMeal from './components/setMeal.vue';
import equipMent from './components/equipMent.vue';
import intro from './components/intro.vue';
import footpannel from './components/fooTer.vue';
import { formRules } from '@/common/util/validator';
import { Public } from '@/http/api_Public';
import banner from "./components/banner.vue" 
import productCharacteristic from "./components/productCharacteristic.vue" 
import productmeal from "./components/productmeal.vue" 
@Component({ 
    components: {
        'v-setMeal':setMeal,
        'v-equipment':equipMent,
        'v-intro':intro,
        'v-footpannel':footpannel,
        'v-banner':banner,
        'v-productCharacteristic':productCharacteristic,
        'v-productmeal':productmeal,
    }, 
})
export default class home extends Vue {
  
    public $refs!: {
       
    };
    
   
    async mounted() {
        
    }
    async created() {
    }
  
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/home.vue